import { FunctionComponent, useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import { ChartData } from "chart.js";

import isDeepEqual from "fast-deep-equal/react";
import { setConstantValue } from "typescript";

type OwnProps = {
  id?: string;
  height?: number;
  width?: number;
  data: ChartData;
};
type Props = OwnProps;

const ChartComponent: FunctionComponent<Props> = ({
  id = `chart-${1000 * Math.random()}`,
  height = 400,
  width = 400,
  data,
}) => {
  const dataRef = useRef(data);
  const chartRef = useRef(null);

  if (!isDeepEqual(dataRef.current, data)) {
    dataRef.current = data;
  }

  useEffect(() => {
    const ctx = document.getElementById(id);

    if (!chartRef.current) {
      const _chart = new Chart(ctx, {
        type: "bar",
        options: {
          plugins: {
            tooltip: {
              enabled: false,
            },
          },
          responsive: true,
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
            },
          },
        },
        data,
      });

      chartRef.current = _chart;
    } else {
      chartRef.current.data = dataRef.current;
      chartRef.current.update();
    }
  }, [dataRef.current]);

  return <canvas id={id} width={width} height={height}></canvas>;
};

export default ChartComponent;
